// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"78d08099","732":"b3ceaf08","977":"b931c4db"}[chunkId] + ".chunk.js";
};